


<div class="card">
    <div class="card-header">
        <div class="row">
          <div class="col-md-8">
            <div class="row">
             
              <div class="col-10 order-md-first text-lg-start d-flex justify-content">
                <div class="col-md-2">

                <button (click)="getback()" class="btn bg-danger-custom" type="button"><i class="feather icon-arrow-left"></i>Back
                </button>
                </div>
                <h4 class="mb-3 mt-3" >{{'Grievance Report ('+GISnumber+')'}}</h4>
            
              </div>
            </div>
          </div>
          </div>
          </div>
          


          <div class="card-body">
              <h6 class="card-title"  style="text-align: left;"> <strong>Current Status </strong></h6>
    
            <aw-wizard #wizardForm [awNavigationMode]="navigationMode">
    
              <aw-wizard-step stepTitle="New">
                </aw-wizard-step>
                <aw-wizard-step stepTitle="IN Progress">
                </aw-wizard-step> <aw-wizard-step stepTitle="Closed">
                </aw-wizard-step> <aw-wizard-step stepTitle="Reoponed">
                </aw-wizard-step>
            
            
            </aw-wizard>
</div></div>          

<div class="card">
    <div class="card-header"  style="text-align: left;"><strong>Transaction Details </strong></div></div>
<div class="card">
    <div class="card-header">
<div class="container">
    <div class="row"> 
       <div class="col-lg-8 text-center" style="padding-top: 20px;"> 
          <div class="container" style="padding-left: 0px; padding-right: 0px;"> 
             <div class="row"> 
                <div class="col-sm" style="text-align: left;"> 
                    <strong> Merchant Name :</strong>  {{ merchantName }} 
                </div> 
               
             </div> 
          </div> 
          <div class="container box" style="margin-top: 10px;"> 

            
            <div class="row"> 
                <div class="col-3" style="text-align: right;">  
                   <strong>Pay Id :</strong> 
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ payId }} 
                </div> 
            
            <div class="row"> 
                <div class="col-3" style="text-align: right;">  
                   <strong>Payment Type :</strong> 
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ paymentMethod }} 
                </div> 
             </div> 
            
            
            
            <div class="row"> 
                <div class="col-3" style="text-align: right;">  
                   <strong>Mop Type :</strong> 
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ mopType }} 
                </div> 
             </div> 
             <div class="row"> 
                <div class="col-3" style="text-align: right;"> 
                   <strong>Amount :</strong> 
                </div> 
                <div class="col" style="text-align: left;">
                   {{ amount }} 
                </div> 
             </div> 
             <div class="row"> 
                <div class="col-3" style="text-align: right;"> 
                   <strong>Total Amount :</strong> 
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ totalAmount }} 
                </div> 
             </div> 
             <div class="row"> 
                <div class="col-3" style="text-align: right;"> 
                   <strong>Transaction Date :</strong> 
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ txnDate }} 
                </div> 
             </div> 

             <div class="row"> 
                <div class="col-3" style="text-align: right;">
                   <strong> Customer Name :</strong>
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ customerName }} 
                </div> 
             </div> 

             <div class="row"> 
                <div class="col-3" style="text-align: right;">
                   <strong> Pg Ref Num :</strong>
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ pgrefNum }} 
                </div> 
             </div> 

             <div class="row"> 
                <div class="col-3" style="text-align: right;"> 
                   <strong>Order ID :</strong> 
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ orderId }} 
                </div> 
             </div> 

             <div class="row"> 
                <div class="col-3" style="text-align: right;">
                   <strong> GRS ID :</strong>
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ grsId }} 
                </div> 
             </div> 
             
             <div class="row"> 
                <div class="col-3" style="text-align: right;">
                   <strong> Grs Description:</strong>
                </div> 
                <div class="col" style="text-align: left;"> 
                   {{ GrsDescription }} 
                </div> 
             </div> 
          </div> 
       </div> 
    </div> 
 </div>
 </div></div>

 
        
           
                                        <div class="col-12">
                                            <div class="card">
                                                <div class="card-header"  style="text-align: left;"><strong> Chat History</strong></div></div>
                                            
                                                
                                                    
                                            
                                            <div id="chat-container" class="chat-container div-class mt-5" style="   margin: 0px 40px 20px 40px;
                                            border-radius: 20px;
                                            border: 1px solid #F8A01D;">
                                                
                                                <div class="chat-box" id="chatBox" >

                                                   <div *ngIf="showError">
                                                      <div class="col" style="text-align: center;"> 
                                                       No Chat Found
                                                      </div>                                                      </div>
                                                </div>
                                               
                                    </div>
                                </div>
                            </div>
                   
        
        
        
        
        
        
  








 <div class="card">
    <div class="card-header"  style="text-align: left;"><strong> History</strong></div></div>
 


 <div class="card">
    <div class="card-header">

        <div class="row" style="min-height: 300px">
            <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine">
              <ag-grid-angular [enableCellTextSelection]=true  (filterModified)="onFilterModified($event)"
                (gridReady)="onGridReady($event)"
                [columnDefs]="tableSelectedColumn" [defaultColDef]="defaultColDef"   
                [paginationPageSize]="pageSize" [pagination]="true" [rowData]="rowData" [rowModelType]=""
                [rowSelection]="'single'" [suppressPaginationPanel]="true" class="ag-theme-alpine"
                style="width: 100%; height: auto;">
              </ag-grid-angular>
            </div>
          </div>
          <div class="row bg-white p-2 mt-0">
          <div class="col-md-8">
            <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
              class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
              <option [ngValue]="10">10</option>
              <option [ngValue]="20">20</option>
              <option [ngValue]="30">30</option>
            </select>
          </div>
          <div class="col-md-4">
            <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
              [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="true"
              class="d-flex justify-content-end col-8 align-right">
            </ngb-pagination>
          </div>
        
          </div>
          </div></div>
         
          
    